import Vue from 'vue';

var eventHub = new Vue();
export default eventHub;


// WEBPACK FOOTER //
// ./resources/assets/js/eventHub.js